var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-page',[_c('app-header',{attrs:{"title":"Anpassen"}}),_c('app-content',[_c('settings-panel',{attrs:{"header-text":_vm.headerText}},_vm._l((_vm.settings),function(setting){return _c('app-list-item',{key:setting.title,attrs:{"value":setting}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }